<template>
  <div>

    <div style="padding-bottom: 50px">



      <!-- <div class="divider dchild">
        {{ gheibats.N_Title }}
      </div> -->

      <v-data-table :items="gheibats.gheibats" :headers="courseHeaders" class="elevation-1" :disable-pagination="true"
        :hide-default-footer="true" :no-data-text="tableText" :header-props="headerProps"></v-data-table>


    </div>
  </div>
</template>

<script>
import { getGheibatSingle } from "@/api/hozoor";
export default {
  props: ["regId"],
  data() {
    return {
      gheibats: {},
      courseHeaders: [
        {
          text: "تاريخ",
          value: "D_Date",
          width: "20%",
          sortable: false,
        },
        {
          text: "نمره/حضور",
          value: "markNoe",
          width: "20%",
          sortable: false,
        },
        { text: "توضيحات", value: "Comment", width: "60%", sortable: false, },
      ],
      headerProps: {
        sortByText: "مرتب سازی بر اساس",
      },
    };
  },
  created() {
    this.getGheibat();
    // window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    // window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },

  methods: {
    getGheibat() {

      getGheibatSingle(this.regId)
        .then((response) => {
          const data = response.data;
          this.gheibats = data;

          this.$store.commit("SET_TABLE_TEXT", false);
          this.$store.commit("SET_HEADER_TITLE", 'حضور و غیاب کلاس ' + data.N_Title);

        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },

  },
};
</script>
<style scoped>
.fixedPosition {
  height: 160px;
  top: 60px;
}
</style>
